export default class Loader {
    constructor(loaderSelector) {
        this.loaderSelector = document.querySelector(loaderSelector)
    }
    init() {
        if (!this.loaderSelector) {
            return
        }
        this.loaderSelector.style.opacity = '1'
    }

    remove() {
        if (!this.loaderSelector) {
            return
        }
        this.loaderSelector.style.transition = '0.8s';
        this.loaderSelector.style.opacity = '0'
    }
    open() {
      if (!this.loaderSelector) {
        return
      }
      this.loaderSelector.style.transition = '0s';
      this.loaderSelector.style.opacity = '1'
    }
}
